import { EnumItemModel } from './ItemModels';

export enum EReportType {
    TimeSession = 0,
    StudySubjectSession = 1,
}

export const ReportTypeEnumItems: ReadonlyArray<EnumItemModel<EReportType>> = [
    { text: 'Number of Sessions', value: EReportType.TimeSession },
    { text: 'Subject Report', value: EReportType.StudySubjectSession }
];
